import DatePicker from './date-picker'

export default {
    install: function(Vue) {
        Vue.component('DatePicker', DatePicker)
    }
}